import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { validaSoloNumero } from "../../util/varios";
import { Mensaje } from "../mensajes2";
import axios from "axios";
import { Dimmer } from "../spinner";
const ImpNovivienda = (props) => {
  const op = require("../../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const [loading, setLoading] = useState(false);
  const [existe, setExiste] = useState(true);
  const [disabled, setDisabled] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [body, setBody] = useState({
    cedula: "",
    constancia: "",
    nomApe: "",
    nomPro: "",
    direInmu: "",
    direPro: "",
    //conf
    confNom: "",
    confCed: "",
    confCiv: "",
    confReso: "",
    confCargo: "",
  });
  const buscarConfiguracion = async () => {
    try {
      setLoading(true);
      const campos = `trim(resolucion) as resolucion, trim(civ) as civ, trim(cedula) as cedula, trim(nombre) as nombre, trim(cargo) as cargo`;
      const tabla = "configcatastro";
      const orden = "1=1";
      const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${tabla}&orden=${orden}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (
        response.status === 200 &&
        response.data &&
        response.data.length > 0
      ) {
        const { resolucion, civ, cedula, nombre, cargo } = response.data[0];
        setBody((prev) => ({
          ...prev,
          confNom: nombre,
          confCed: cedula,
          confCiv: civ,
          confReso: resolucion,
          confCargo: cargo,
        }));
      }
    } catch (error) {
      setDisabled(true);
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response
          ? error.response.data.message
          : "Error al Buscar la Configuracion`",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const buscarInmueble = async (id) => {
    try {
      setLoading(true);
      const campos = `
      TRIM(dirinmue1) || ' ' || 
      TRIM(descridirinmue1) || ' ' || 
      TRIM(dirinmue2) || ' ' || 
      TRIM(descridirinmue2) || ' ' || 
      TRIM(dirinmue5) || ' ' || 
      TRIM(descridirinmue5) || ' ' || 
      TRIM(numcivicoinmue) || ' ' || 
      TRIM(parroquia) as direccion_inmueble,
      TRIM(nombrepropie),
      TRIM(ciudadpropie) || ' ' || 
      TRIM(dirpropie1) || ' ' || 
      TRIM(descridirpropie1) || ' ' || 
      TRIM(dirpropie2) || ' ' || 
      TRIM(descridirpropie2) || ' ' || 
      TRIM(dirpropie5) || ' ' || 
      TRIM(numcivicopropie) as direccion_propietario
      `;
      const tabla = `inmueble
      `;
      const nomid = "TRIM(REPLACE(cedulapropie,'.',''))";
      const endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${tabla}&nomid=${nomid}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data) {
        setExiste(true);
        const { data } = response;
        setBody((prev) => ({
          ...prev,
          direPro: data.direccion_propietario,
          direInmu: data.direccion_inmueble,
          nomPro: data.nombrepropie,
        }));
        setMensaje({
          mostrar: true,
          titulo: "Informacion",
          texto:
            "El Solicitante Posee al Menos una Propiedad Inmobiliaria en este Municipio",
          icono: "informacion",
        });
        setDisabled(true);
      } else {
        setExiste(false);
        setMensaje({
          mostrar: true,
          titulo: "Informacion",
          texto: "No hay ningún inmueble asociado al soliciante",
          icono: "informacion",
        });
        setBody((prev) => ({
          ...prev,
          constancia: "",
          nomApe: "",
          nomPro: "",
          direInmu: "",
          direPro: "",
        }));
        setDisabled(false);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response
          ? error.response.data.message
          : "Error al Buscar el inmueble",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const validarClasificador = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        buscarInmueble(event.target.value.replace(/\./g, ""));
      }
    }
  };
  const onChange = (e) => {
    const { name, value } = e.target;
    setBody((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const blanquear = () => {
    setDisabled(true);
    setBody({
      cedula: "",
      constancia: "",
      nomApe: "",
      nomPro: "",
      direInmu: "",
      direPro: "",
      //conf
      confNom: "",
      confCed: "",
      confCiv: "",
      confReso: "",
      confCargo: "",
    });
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setExiste(true);
    setLoading(false);
  };
  const imprimir = () => {
    try {
      if (
        !body.cedula ||
        !body.nomApe ||
        !body.constancia ||
        !body.confNom ||
        !body.confCed ||
        !body.confCiv ||
        !body.confReso
      ) {
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: "Faltan Datos Obligatorios para Generar el Reporte",
          icono: "error",
        });
        return;
      }
      window.open(
        `${
          op.reportes
        }/catastro?reporte=ForConstanciaCatastro&NOMBRE=${body.nomApe}&CEDULA=V.-${body.cedula}&CONSTANCIA=${body.constancia.trim().toUpperCase()}&NOMBREDIR=${body.confNom}&CEDULADIR=${body.confCed}&CIV=${body.confCiv}&RESOLUCION=${body.confReso}&CARGO=${body.confCargo}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "",
        texto: "Error al Generar el Reporte",
        icono: "error",
      });
    }
  };
  const salir = () => {
    props.setTabla(0);
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgba(0, 0, 0, 0.521)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        buscarConfiguracion();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-5 fw-bold text-light m-0">
          Constancia de no Poseer Vivienda
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between">
          <div className="col-md-3 row py-2">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Cedula:
              </span>
              <input
                type="text"
                onKeyUp={validarClasificador}
                className="form-control text-uppercase text-right"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                name="cedula"
                onChange={onChange}
                value={body.cedula}
              />
            </div>
          </div>
        </div>

        {!existe ? (
          <>
            <div className="d-flex justify-content-between">
              <div className="col-md-12 row py-2">
                <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Número de la Constancia:
                  </span>
                  <input
                    type="text"
                    className="form-control text-uppercase text-left"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    name="constancia"
                    onChange={onChange}
                    value={body.constancia}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="col-md-12 row py-2">
                <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Nombres y Apellidos:
                  </span>
                  <input
                    type="text"
                    className="form-control text-uppercase text-left"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    name="nomApe"
                    onChange={onChange}
                    value={body.nomApe}
                  />
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="d-flex justify-content-between">
              <div className="col-md-12 row py-2">
                <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Nombre del Propietario:
                  </span>
                  <input
                    type="text"
                    className="form-control text-uppercase text-left"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    name="nomPro"
                    value={body.nomPro}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="col-md-12 row py-2">
                <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Dirección de Inmueble:
                  </span>
                  <textarea
                    type="text"
                    className="form-control text-uppercase text-left"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    name="direInmu"
                    value={body.direInmu}
                    disabled
                    style={{ height: 60 }}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="col-md-12 row py-2">
                <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Dirección del Propietario:
                  </span>
                  <textarea
                    type="text"
                    className="form-control text-uppercase text-left"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    name="direPro"
                    value={body.direPro}
                    disabled
                    style={{ height: 60 }}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => imprimir()}
          disabled={disabled}
          className="btn-sm rounded-pill btn btn-primary col-md-2"
        >
          <i className="fas fa-print"></i> Imprimir
        </button>
        <button
          onClick={() => blanquear()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fas fa-trash"></i> Cancelar
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
      <Dimmer active={loading} inverted />
    </Modal>
  );
};

export default ImpNovivienda;
